<template>
  <section>
    <v-row class="pa-4">
      <v-col class="col-9">
        <product-selector
          multi-select
          :selected-products.sync="selectedProducts"
          :products-and-events="productsInstance.getProducts()"
        />
      </v-col>

      <v-col class="col-3 text-right">
        <enter-booking-btn />
      </v-col>
    </v-row>
    <v-row class="pa-4">
      <v-col>
        <capacity-calendar
          v-if="selectedProducts.length > 0"
          :products="selectedProducts"
          hide-select-periode
          hide-description
          hide-sibling-product
          :hide-plus-button="appUserInstanceCanCreateNewBooking"
          @date-changed="dateChanged"
          @capacityOverridden="fetchCapacities()"
          @click:day="createNewBooking"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script>
import CapacityCalendar from '../capacityCalendar/CapacityCalendar'
import moment from 'moment'
import Products from '../../classes-shared/products/Products'
import EnterBookingBtn from './EnterBookingBtn'
import EventHelper from '../../classes-shared/events/EventHelper'
import ProductSelector from '../../components-shared/products/ProductSelector'
import NavigationStoreMixin from '../../components-shared/mixins/NavigationStoreMixin'
import definitions from '../../../definitions'

export default {
  name: 'BookingCalendar',
  components: {
    ProductSelector,
    CapacityCalendar,
    EnterBookingBtn,
  },
  mixins: [NavigationStoreMixin],

  data() {
    return {
      productsInstance: new Products(),
      selectedProducts: [],
      eventHelper: new EventHelper(),
      dateRange: {
        from: moment().startOf('month'),
        to: moment().startOf('month').add(1, 'month'),
      },
    }
  },

  asyncComputed: {
    // permission short cut
    async appUserInstanceCanCreateNewBooking() {
      return await this.$store.getters
        .getAppUserInstance()
        .doIHavePermissionInTheCurrentDestinationForKey(
          definitions.permissions.shopApi.BOOKING_ADMIN_CHECKOUT
        )
    },
  },

  watch: {
    selectedProducts() {
      this.selectedProducts.forEach((product) => {
        if (product.isEventTemplate()) {
          this.eventHelper.fetchEventsFromApi(
            this.selectedProducts,
            true,
            true,
            'future',
            this.dateRange.from,
            this.dateRange.to
          )
        }
        product.fetchCapacities(this.dateRange.from, this.dateRange.to)
      })
      this.storeObject['selectedProducts'] = this.selectedProducts
    },
  },

  async mounted() {
    await this.productsInstance.loadProducts()
    if (this.storeObject.selectedProducts)
      this.selectedProducts = this.storeObject.selectedProducts
  },

  methods: {
    dateChanged(dateRange) {
      this.dateRange = dateRange
      this.selectedProducts.forEach((product) => {
        product.fetchCapacities(this.dateRange.from, this.dateRange.to)
      })
    },
    createNewBooking(date) {
      this.$router.push({
        name: 'createBookingOverview',
        params: { date: new Date(date.date) },
      })
    },
    // re-load capacities of selected products
    fetchCapacities() {
      for (let i = 0; i < this.selectedProducts.length; i++) {
        this.selectedProducts[i].fetchCapacities(
          this.dateRange.from,
          this.dateRange.to,
          true
        )
      }
    },
  },
}
</script>
